<svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="4" y="7.02295" width="2.63272" height="15" rx="1.31636" transform="rotate(-48.7887 4 7.02295)" fill="#21272A"/>
<rect x="17.7178" y="0.465332" width="2.63272" height="15" rx="1.31636" transform="rotate(-10.1819 17.7178 0.465332)" fill="#21272A"/>
<rect y="17.5381" width="2.63272" height="15" rx="1.31636" transform="rotate(-71.4205 0 17.5381)" fill="#21272A"/>
</svg>
